import { createPrefetchableAsyncDataContext, pageDataErrorHandler } from 'src/app/shared/contexts/asyncData';

import { getPsfPromoteOrSharePageData } from './api';
import type { PsfPromoteOrSharePageDataErrorCode } from './types';

export const {
	Context: PsfPromoteOrSharePageDataContext,
	Provider: PsfPromoteOrSharePageDataContextProvider,
	useContext: usePsfPromoteOrSharePageData,
	useAsyncData: usePsfPromoteOrSharePageDataFromApi,
	prefetchAsyncData: prefetchPsfPromoteOrSharePageDataFromApi,
} = createPrefetchableAsyncDataContext({
	name: 'PsfPromoteOrSharePageDataContext',
	dataProperty: 'pageData',
	getData: getPsfPromoteOrSharePageData,
	getUniqueId: (slug) => slug,
	hookDeps: (slug) => [slug],
	errorHandler: pageDataErrorHandler<PsfPromoteOrSharePageDataErrorCode>(),
});
